import { i18n } from '@/i18n';
import { Component, Vue } from "vue-property-decorator";
import { IAnswer, IGalaxy, ILevel, IMessage, ISession, Series } from '../api_interface';

function now() {
  return Number(new Date()) / 1000
}

@Component
export class GalaxyCruiseStore extends Vue {
  series: Series | null = null

  session: ISession | null = null
  targetGalaxy: IGalaxy | null = null

  showSpecialityItems = false
  showMyPage = false
  showPassport = false
  showConfig = false

  all_messages: IMessage[] = []

  now = now()

  created() {
    setInterval(() => {
      this.now = now()
    }, 1000)
  }

  get messages() {
    if (i18n.locale === 'ja') {
      return this.all_messages.filter(m => m.ja_title.length > 0)
    }
    else {
      return this.all_messages.filter(m => m.en_title.length > 0)
    }
  }

  get quest() {
    return this.session!.quest
  }

  get doneGalaxies() {
    const done_galaxy_ids = new Set(this.session!.quest.answers.map((a) => a.galaxy_id))
    return this.session!.quest.galaxies.filter((g) => done_galaxy_ids.has(g.id))
  }

  get undoneGalaxies() {
    const done_galaxy_ids = new Set(this.session!.quest.answers.map((a) => a.galaxy_id))
    return this.session!.quest.galaxies.filter((g) => !done_galaxy_ids.has(g.id))
  }

  get nextQuestion(): IGalaxy | undefined {
    const a = this.undoneGalaxies
    let i = -1
    if (this.targetGalaxy) {
      i = a.findIndex((g) => g.id === this.targetGalaxy!.id)
    }
    return a[(i + 1) % a.length]
  }

  get galId2answer() {
    const dic: { [galaxy_id: string]: IAnswer } = {}
    for (const a of this.quest.answers) {
      dic[a.galaxy_id] = a
    }
    return dic
  }

  get cabinGrade() {
    switch (this.series) {
      case 'infinite':
        return -1
      case 'training':
        return 4
      default: {
        const l = this.session!.quest.level.id
        if (l <= 2) {
          return 4
        }
        if (l <= 4) {
          return 3
        }
        if (l <= 6) {
          return 2
        }
        if (l <= 8) {
          return 1
        }
        return 0
      }
    }
  }

  get specialityGoodsCount() {
    if (this.series !== 'season_1') {
      return -1
    }
    const session = this.session!
    const levelId = session.quest.level.id
    let dt = session.record.done_tracts + (this.seriesDone ? 1 : 0)
    let nItems = 0
    let level: ILevel
    for (level of session.levels) {
      if (level.id >= levelId) {
        break
      }
      dt -= level.num_tracts
      nItems += level.num_goods
    }
    nItems += Math.floor(level!.num_goods * dt / level!.num_tracts)
    return nItems
  }

  get seriesDone() {
    return this.session && this.session.series_done
  }
}
